// extracted by mini-css-extract-plugin
export default {"pl":"LoaderBig_pl__Lk2ba","pl__ring":"LoaderBig_pl__ring__+Ant6","pl__ball":"LoaderBig_pl__ball__04W4e","ring":"LoaderBig_ring__yzzmn","ball":"LoaderBig_ball__HY52R"};